import { Product } from "@/api/product-api";
import { useTranslation } from "next-i18next";

type Namespace =
  | "index"
  | "gnb"
  | "software"
  | "tactsuit"
  | "games"
  | "checkout"
  | "tracking"
  | "shop"
  | "support"
  | "about"
  | "blog"
  | "where-to-try"
  | "event"
  | "trade-in";

export const useTrans = (namespaces: Namespace[] = ["gnb"]) => {
  const { t, i18n } = useTranslation(namespaces);

  // 제품번역 함수
  const translateProduct = (p: Product): Product => ({
    ...p,
    desc: t(p?.desc ?? ""),
    shortDesc: t(p?.shortDesc ?? ""),
  });

  return {
    t,
    i18n,
    tp: translateProduct,
  };
};
